const md5 = require('md5');

const leftEnds = ['gt', 'ge'];
const rightEnds = ['lt', 'le'];
const props = rightEnds.concat(leftEnds);

const endpointTest = {
  lt: (max, getValue) => max > 0 && getValue() < max,
  le: (max, getValue) => max === 1 || getValue() <= max,
  gt: (min, getValue) => min < 1 && getValue() > min,
  ge: (min, getValue) => min === 0 || getValue() >= min
};

module.exports = {
  validate(rule) {
    if (!rule.idType) {
      return {
        isValid: false,
        message: 'Id percentage rules must have an idType'
      };
    }
    let endpointCount = 0;

    for (var i = 0; i < props.length; i++) {
      const prop = props[i];
      if (prop in rule) {
        const value = rule[prop];

        if (isNaN(value) || value < 0 || value > 1) {
          return {
            isValid: false,
            message: `Invalid percentage ${value}; must be a number between 0.0 and 1.0.`
          };
        }

        if (
          endpointCount > 0 &&
          ((rightEnds.indexOf(prop) >= 0 &&
            leftEnds.some(prop => prop in rule && rule[prop] >= value)) ||
            (leftEnds.indexOf(prop) >= 0 &&
              rightEnds.some(prop => prop in rule && rule[prop] <= value)))
        ) {
          return { isValid: false, message: 'Ranges do not overlap' };
        }

        endpointCount++;
      }
    }

    if (endpointCount === 0) {
      return {
        isValid: false,
        message:
          'You must provide a percentage range using lt, le, gt, and/or ge properties'
      };
    }

    return { isValid: true };
  },

  test({ key, rule, params = {} }) {
    const { idType, salt } = rule;
    const id = params[idType];
    if (!id) {
      return false;
    }

    // Only lazily compute the hash/percentage to enable logic short-circuiting
    // so that 100% and 0% rules are less costly
    let percentage = null;
    function getPercentage() {
      if (percentage === null) {
        const hash = md5(`${id}${salt ?? key}`);
        percentage = parseInt(hash.substring(0, 8), 16) / 0xffffffff;
      }
      return percentage;
    }

    for (let i = 0; i < props.length; i++) {
      const prop = props[i];
      if (prop in rule
        && rule[prop] !== null
        && !endpointTest[prop](rule[prop], getPercentage)
      ) {
        return false;
      }
    }

    return true;
  }
};
